import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { AuthenticationService } from './authentication.service';
import { GlobalDataService } from './global-data.service';
import { VaultService } from './vault.service';
import { USER_OBJECT } from './vault-service.constants';
import { ClearCacheService } from './clear-cache.service';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  public alertPresented: any;
  isContinueSession = false;
  constructor(
    public alertCtrl: AlertController,
    public globalData: GlobalDataService,
    public router: Router,
    private clearCache: ClearCacheService,
    private vaultService: VaultService,
    public authService: AuthenticationService
  ) {
    this.alertPresented = false;
  }

  async presentAlert(title: any, subTitle: any) {
    this.isContinueSession = false;
    const vm = this;
    let alc: any = await vm.alertCtrl.create({
      header: title,
      subHeader: subTitle,
      buttons: [
        {
          text: 'Continue',
          handler: async data => {
            alc.dismiss();
            alc = null;
            this.isContinueSession = true;
          },
        },
        {
          text: 'Logout',
          handler: async data => {
            alc.dismiss();

            this.cleanupDataAndLogout();
            this.isContinueSession = false;
            alc = null;
          },
        },
      ],
      backdropDismiss: false,
    });
    await alc.present();
  }

  async cleanupDataAndLogout() {
    this.vaultService.setKeyValue(USER_OBJECT, '');
    this.globalData.isLogout = true;
    this.isContinueSession = false;
    this.authService.clearUserObject();
    await this.reload();
  }
  private async reload() {
    await this.vaultService.clearVault();
    await this.authService.isAuthenticated.next(false);
    await this.clearCache.clearCacheForFile('index.html');
    document.location.href = 'index.html';
  }
}
